import { z } from "zod";
export const UserAnalyticsCleanupSchedule = z.object({
    userId: z.string(),
    createdAt: z.coerce.date(),
    deleteAt: z.coerce.date(),
});
export const UserAnalyticsCleanupScheduleDbInput = UserAnalyticsCleanupSchedule.omit({
    createdAt: true,
});
